import * as React from "react";
import { forwardRef } from "react";
const SvgDots = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 4, viewBox: "0 0 18 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 2, cy: 2, r: 1.5, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 9, cy: 2, r: 1.5, fill: "currentColor" }), /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 2, r: 1.5, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgDots);
export default ForwardRef;
